// Hold to talk (branch sop-visual): press and hold, speak, let go -> text. The existing transcription (/api/ai?transcribe=1, src/lib/voice.js);
// when it fails the phone's own speech recognition is tried; with neither, a text box. No new service. onText(text) gets what was heard.
import { useRef, useState } from 'react'
import { canRecord, canBrowserListen, startRecording, transcribe, browserListen, TOO_SHORT } from '../lib/voice'
import { Ico, btn } from './SopVisual'
import { BRAND } from '../lib/sopVisual'

export default function HoldToTalk({ onText, label = 'Hold to talk', big = false }) {
  const rec = useRef(null)
  const [state, setState] = useState('idle')   // idle | rec | work
  const [err, setErr] = useState('')
  const [typed, setTyped] = useState('')
  const voice = canRecord() || canBrowserListen()
  async function start(e) {
    if (e && e.preventDefault) e.preventDefault()
    if (state !== 'idle') return
    setErr('')
    try {
      if (canRecord()) { rec.current = await startRecording({ maxMs: 60000 }); rec.current.kind = 'audio' }
      else { rec.current = browserListen(); rec.current.kind = 'browser' }
      setState('rec')
    } catch (x) { setErr('The microphone is not available - type it instead.'); setState('idle') }
  }
  async function stop() {
    const r = rec.current
    if (!r || state !== 'rec') return
    setState('work')
    try {
      if (r.kind === 'audio') {
        const blob = await r.stop()
        let text = ''
        try { text = await transcribe(blob) } catch (x) {
          if (canBrowserListen()) { setErr('Could not transcribe (' + x.message + '). Type it, or hold again to let the phone listen.'); rec.current = null; setState('idle'); return }
          throw x
        }
        if (text) onText(text); else setErr(TOO_SHORT)
      } else { r.stop(); const text = await r.done; if (text) onText(text); else setErr(TOO_SHORT) }
    } catch (x) { setErr('Could not hear that: ' + (x.message || x)) }
    rec.current = null; setState('idle')
  }
  return (
    <div>
      {voice && (
        <button type="button" aria-label={label} aria-pressed={state === 'rec'}
          onPointerDown={start} onPointerUp={stop} onPointerLeave={() => state === 'rec' && stop()} onContextMenu={e => e.preventDefault()}
          style={{ ...btn, width: '100%', minHeight: big ? 84 : 56, fontSize: big ? 19 : 16, background: state === 'rec' ? '#B3261E' : BRAND.navy, color: '#fff', borderColor: state === 'rec' ? '#B3261E' : BRAND.navy, touchAction: 'none', userSelect: 'none', WebkitUserSelect: 'none' }}>
          <Ico name="play" size={big ? 28 : 22} />{state === 'rec' ? 'Listening… let go to finish' : state === 'work' ? 'Writing it down…' : label}
        </button>
      )}
      <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
        <input value={typed} onChange={e => setTyped(e.target.value)} placeholder={voice ? 'or type a short answer' : 'Type a short answer'} aria-label="Type the answer"
          onKeyDown={e => { if (e.key === 'Enter' && typed.trim()) { onText(typed.trim()); setTyped('') } }}
          style={{ flex: 1, minHeight: 44, padding: '8px 12px', fontSize: 16, borderRadius: 10, border: '1px solid ' + BRAND.line, fontFamily: 'inherit' }} />
        <button type="button" style={btn} disabled={!typed.trim()} onClick={() => { onText(typed.trim()); setTyped('') }}>Add</button>
      </div>
      {err && <div role="alert" style={{ color: '#7A1212', fontSize: 13, marginTop: 6 }}>{err}</div>}
    </div>
  )
}
